/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Staking, StakingInterface } from "../../contracts/Staking";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "contract ERC20",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_stakeDuration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minimumTimelock",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "AmountInvalid",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "DelayInvalid",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "DelegateInvalid",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "DelegateNotProposed",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "DelegateNotSet",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "DelegateStaked",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "DelegateTaken",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "DurationInvalid",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "delegate",
        type: "address",
      },
    ],
    name: "SenderHasDelegate",
    type: "error",
  },
  {
    inputs: [],
    name: "TimelockActive",
    type: "error",
  },
  {
    inputs: [],
    name: "TimelockInactive",
    type: "error",
  },
  {
    inputs: [],
    name: "Timelocked",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [],
    name: "CancelDurationChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "newDuration",
        type: "uint256",
      },
    ],
    name: "CompleteDurationChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "ProposeDelegate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "proposedStakeDuration",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "unlockTimestamp",
        type: "uint256",
      },
    ],
    name: "ScheduleDurationChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "delegate",
        type: "address",
      },
    ],
    name: "SetDelegate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "unlock",
        type: "bool",
      },
    ],
    name: "SetUnlocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokens",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "delegate",
        type: "address",
      },
    ],
    name: "UnsetDelegate",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_from",
        type: "address",
      },
    ],
    name: "acceptDelegateProposal",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "available",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cancelDurationChange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "completeDurationChange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address",
      },
    ],
    name: "delegateStakers",
    outputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_to",
        type: "address",
      },
    ],
    name: "proposeDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "proposedDelegates",
    outputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_proposedStakeDuration",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_durationChangeDelay",
        type: "uint256",
      },
    ],
    name: "scheduleDurationChange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    name: "setMetaData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_unlocked",
        type: "bool",
      },
    ],
    name: "setUnlocked",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakeDuration",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stakeFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "stakerDelegates",
    outputs: [
      {
        internalType: "address",
        name: "delegate",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "stakes",
    outputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "finish",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract ERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_delegate",
        type: "address",
      },
    ],
    name: "unsetDelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "unstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type StakingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: StakingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Staking__factory extends ContractFactory {
  constructor(...args: StakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _name: string,
    _symbol: string,
    _stakingToken: string,
    _stakeDuration: BigNumberish,
    _minimumTimelock: BigNumberish,
    overrides?: Overrides & { from?: string }
  ): Promise<Staking> {
    return super.deploy(
      _name,
      _symbol,
      _stakingToken,
      _stakeDuration,
      _minimumTimelock,
      overrides || {}
    ) as Promise<Staking>;
  }
  override getDeployTransaction(
    _name: string,
    _symbol: string,
    _stakingToken: string,
    _stakeDuration: BigNumberish,
    _minimumTimelock: BigNumberish,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _name,
      _symbol,
      _stakingToken,
      _stakeDuration,
      _minimumTimelock,
      overrides || {}
    );
  }
  override attach(address: string): Staking {
    return super.attach(address) as Staking;
  }
  override connect(signer: Signer): Staking__factory {
    return super.connect(signer) as Staking__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingInterface {
    return new utils.Interface(_abi) as StakingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Staking {
    return new Contract(address, _abi, signerOrProvider) as Staking;
  }
}
